import React from 'react'
import * as S from './InfiniteLoader.styles';

import useIntersectionObserver from '../../../../../../hooks/use-intersection-observer';

interface IInfinite {
    showLoader: boolean;
    actionHandler: () => void;
    children: any;
    root?: any
}

export default function ({ actionHandler = () => {}, children, showLoader = false, root = null }: IInfinite) {
    const [ref] = useIntersectionObserver({
        root: root,
        rootMargin: "0px",
        threshold: 1.0
      },
      actionHandler
    );

    return (
        <S.InfiniteLoaderContainer>
            {children}
            <div ref={ref} className={showLoader ? "loader" : ""}></div>
        </S.InfiniteLoaderContainer>
    )
}